export default __webpack_public_path__ + "static/media/meetings-icon.e01a3f70.png";